import classes from './MainScreen.module.scss';
import Container from "../Container/Container";
import card1 from '../../../assets/images/card1.png';
import card2 from '../../../assets/images/card2.png';
import card3 from '../../../assets/images/card3.png';
import card4 from '../../../assets/images/card4.png';
import card5 from '../../../assets/images/card5.png';
import bgItems from '../../../assets/images/header-bg-items.png';
import { useTranslation } from "react-i18next";

const cards = [card1, card2, card3, card4, card5];

const MainScreen = () => {
  const { t } = useTranslation();

  return (
    <div className={classes['container']}>
      <img src={bgItems} alt='' className={classes.bgItems} />
      <Container style={{ height: '100%', minHeight: 'unset' }}>
        <div className={classes.inner}>
          <div className={classes.text}>
            <h1>{t('pages.main.welcome.title')}</h1>
            <p>{t('pages.main.welcome.subtitle')}</p>
            <div className={classes.cards}>
              {cards.map((src, i) => (
                <img key={i} src={src} alt='' />
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default MainScreen;
